<template>

    <main class="error-not-found">

        <div class="image">
            <img
                    src="/img/img_404.svg"
                    alt="404 ERROR"
            >
        </div>

        <div class="info">

            <h2 class="info-heading">
                Huch! Diese Seite konnte leider nicht gefunden werden.
            </h2>

            <p class="info-text">
                Vielleicht wurde die URL falsch eingegeben oder der Link ist veraltet? Kein Problem, denn über die Startseite
                oder die Suche im Menü gelangst du einfach zum gewünschten Thema rund um HIV.
            </p>

        </div>

    </main>

</template>

<script>

    // console.log('ErrorNotFound');

    export default {
        components : {},
        methods : {},
    }

</script>

<style lang="scss">

    @import '../../css/variables';

    .error-not-found {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        min-height: 100vh;
        padding: 5.5rem 0 5.5rem 0;
        background-color: $color-nochvielvor-black;
        @media screen and (max-width: 767px) {
            flex-direction: column;
            padding: 5.5rem * $factor-1200 1.5rem 5.5rem * $factor-1200 1.5rem;
        }
        @media screen and (min-width: 1200px) {
            padding: 5.5rem * $factor-1200 0 5.5rem * $factor-1200 0;
        }
        @media screen and (min-width: 1440px) {
            padding: 5.5rem * $factor-1440 0 5.5rem * $factor-1440 0;
        }
        @media screen and (min-width: 1920px) {
            padding: 5.5rem * $factor-1920 0 5.5rem * $factor-1920 0;
        }
        @media screen and (min-width: 2400px) {
            padding: 5.5rem * $factor-2400 0 5.5rem * $factor-2400 0;
        }
        .image {
            max-width: 25%;
            padding-right: 2.5%;
            @media screen and (max-width: 767px) {
                width: 50%;
                max-width: 50%;
                padding-right: 0;
                padding-bottom: 2rem;
            }
            img {
                width: 100%;
                height: auto;
            }
        }
        .info {
            display: flex;
            flex-direction: column;
            max-width: 37.5%;
            @media screen and (max-width: 767px) {
                width: 100%;
                max-width: 20rem;
            }
            .info-heading {
                margin: auto 0 1rem 0;
                color: $color-nochvielvor-white;
                font-size: 1.5rem;
                @media screen and (max-width: 767px) {
                    text-align: center;
                }
                @media screen and (min-width: 1200px) {
                    font-size: 1.5rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    font-size: 1.5rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    font-size: 1.5rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    font-size: 1.5rem * $factor-2400;
                }
            }
            .info-text {
                margin: 0 0 auto 0;
                color: $color-nochvielvor-white;
                font-size: 0.75rem;
                @media screen and (max-width: 767px) {
                    text-align: center;
                }
                @media screen and (min-width: 1200px) {
                    font-size: 0.75rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    font-size: 0.75rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    font-size: 0.75rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    font-size: 0.75rem * $factor-2400;
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// public/js/components/ErrorNotFound.vue